import { render, staticRenderFns } from "./CompleteNewPassword.vue?vue&type=template&id=b0eb73d0&scoped=true&"
import script from "./CompleteNewPassword.vue?vue&type=script&lang=ts&"
export * from "./CompleteNewPassword.vue?vue&type=script&lang=ts&"
import style0 from "./CompleteNewPassword.vue?vue&type=style&index=0&id=b0eb73d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0eb73d0",
  null
  
)

export default component.exports